"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMantineTheme = void 0;
var theme_context_1 = require("../MantineProvider/theme-context");
var merge_theme_1 = require("../utils/merge-theme/merge-theme");
var default_theme_1 = require("../default-theme");
function useMantineTheme(themeOverride) {
    var internalTheme = __assign({}, theme_context_1.useTheme());
    var mergedTheme = null;
    if (!internalTheme.__mantine_theme) {
        mergedTheme = merge_theme_1.mergeTheme(__assign({ __mantine_theme: true }, default_theme_1.DEFAULT_THEME), themeOverride);
    }
    else {
        mergedTheme = merge_theme_1.mergeTheme(internalTheme, themeOverride);
    }
    delete mergedTheme.__mantine_theme;
    return mergedTheme;
}
exports.useMantineTheme = useMantineTheme;
